module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-right.6bb1f78b.svg";